import request from "root/js/request";

export const getSocialBloggersSimilar = async ({
  account_name_hash,
  source,
  ordering,
  limit = 1000,
  offset,
}) => {
  const response = await request({
    url: `parsers/social/bloggers/similar/`,
    method: "post",
    params: {
      ordering,
      limit,
      offset,
    },
    data: {
      account_name_hash,
      source,
    },
  });
  return response.data;
};
